import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriUpdatePasswordComponent } from '../../components/gonvarri-update-password/gonvarri-update-password.component';
import { AuthGuard, AuthRedirectService, AuthService, FeaturesConfigModule, GlobalMessageService, I18nModule, provideConfig, RoutingService, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule, MessageComponentModule, PasswordVisibilityToggleModule, SpinnerModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { UserPasswordFacade } from '@spartacus/user/profile/root';
import { GonvarriUpdatePasswordComponentService } from 'src/app/core/services/gonvarri-update-password-component.service';

@NgModule({
  declarations: [
    GonvarriUpdatePasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    I18nModule,
    FormErrorsModule,
    UrlModule,
    RouterModule,
    PasswordVisibilityToggleModule,
    FeaturesConfigModule,
    MessageComponentModule,
  ],
  exports: [
    GonvarriUpdatePasswordComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        GonvarriUpdatePasswordComponent: {
          component: GonvarriUpdatePasswordComponent
        },
        UpdatePasswordComponent: {
          component: GonvarriUpdatePasswordComponent,
          guards: [AuthGuard],
          providers: [
            {
              provide: GonvarriUpdatePasswordComponentService,
              useClass: GonvarriUpdatePasswordComponentService,
              deps: [
                UserPasswordFacade,
                RoutingService,
                GlobalMessageService,
                AuthRedirectService,
                AuthService,
              ],
            },
          ],
        },
      }
    })
  ]
})
export class GonvarriUpdatePasswordModule { }
